import { render, staticRenderFns } from "./PageGoodsList.vue?vue&type=template&id=a655c9e2&scoped=true"
import script from "./PageGoodsList.vue?vue&type=script&lang=js"
export * from "./PageGoodsList.vue?vue&type=script&lang=js"
import style0 from "./PageGoodsList.vue?vue&type=style&index=0&id=a655c9e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a655c9e2",
  null
  
)

export default component.exports